import React, { useState } from "react";
import Tabs from "../Tabs/Tabs";
import NftCard from "../NftCard/NftCard";
import StyledH6Heading from "../../common/components/styledH6Heading/StyledH6Heading";
import { useGetLikedNft } from "../../Hooks/api/useGetLikeNft";
import { usePurchasedNft } from "../../Hooks/api/usePurchasedNft";
import { useAccount } from "wagmi";
import Pagination from "../Pagination/Pagination";
import NFTSkeltonLoader from "../Loader/nft-skelton-loader";
import StyledH5Heading from "../../common/components/styledH5Heading/StyledH5Heading";
import StyledLgText from "../../common/components/styledLgText/StyledLgText";

const ProfileCollectionNfts = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeTab, setActiveTab] = useState("My Collection");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 16;

  const { address } = useAccount();
  const { data: likedNftsData, isLoading: isLikedLoading } = useGetLikedNft({
    tier: activeCategory.replace(/\s+/g, ""),
    walletAddress: address,
  });

  const {
    data: purchasedNftsData,
    isLoading: isPurchasedLoading,
  } = usePurchasedNft({
    tier: activeCategory.replace(/\s+/g, ""),
    walletAddress: address,
  });

  const handleTabClick = (index, tab) => {
    setActiveTab(tab);
    setCurrentPage(1);
  };

  const handleCategoryClick = (index, category) => {
    const selectedTier = tiersLevels[index].value;
    setActiveCategory(selectedTier);
    setCurrentPage(1);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const tiersLevels = [
    { Title: "All", value: "All" },
    { Title: "Tier 1", value: "Tier 1" },
    { Title: "Tier 2", value: "Tier 2" },
    { Title: "Tier 3", value: "Tier 3" },
    { Title: "Tier 4", value: "Tier 4" },
    { Title: "Tier 5", value: "Tier 5" },
    { Title: "Metaverse", value: "Metaverse" },
  ];

  const profileTabName = [{ Title: "My Collection" }, { Title: "Wishlist" }];

  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-[90%] sm:w-[85%] md:w-[80%] flex flex-col md:flex-row justify-between items-start gap-5">
        <div className="hidden lg:flex flex-col gap-2 w-full md:w-[18%]">
          <div>
            <StyledH6Heading>Show By:</StyledH6Heading>
          </div>
          <Tabs
            custom
            id="tier-levels"
            width={"w-full !justify-start md:!justify-between gap-2"}
            data={tiersLevels}
            activeCategory={activeCategory}
            handleCategoryClick={handleCategoryClick}
          />
        </div>
        <hr className="hidden lg:flex h-[158px] w-[1px] bg-white opacity-30" />

        <div className="w-full lg:w-[80%] flex flex-col gap-5">
          <div className="flex gap-2 items-center">
            <Tabs
              id="profile-tabs"
              width={
                "w-full !justify-start pl-2 md:pl-5 rounded-md md:rounded-md "
              }
              data={profileTabName}
              activeCategory={activeTab}
              handleCategoryClick={handleTabClick}
            />

            <div
              className="lg:hidden flex items-center border border-bright-yellow rounded-md p-2 self-stretch cursor-pointer"
              onClick={toggleDropdown}
            >
              <img src="/assets/menu-tiers.svg" alt="dropdown" loading="lazy" />
            </div>
          </div>

          {isDropdownOpen && (
            <Tabs
              custom
              width={
                "w-1/2 sm:w-1/3 ratingGradient p-2 rounded-md !justify-start md:!justify-between gap-2"
              }
              data={tiersLevels}
              activeCategory={activeCategory}
              handleCategoryClick={handleCategoryClick}
            />
          )}

          <div
            className={`w-[100%] md:w-full mx-auto flex ${
              (activeTab === "Wishlist" &&
                !isLikedLoading &&
                !likedNftsData?.length) ||
              (activeTab === "My Collection" &&
                !isPurchasedLoading &&
                !purchasedNftsData?.length)
                ? "justify-center items-center h-[300px]"
                : "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4"
            }`}
            style={{ minHeight: "260px" }}
          >
            {activeTab === "Wishlist" ? (
              isLikedLoading ? (
                [...Array(4)].map((_, index) => (
                  <NFTSkeltonLoader key={index} />
                ))
              ) : likedNftsData?.length > 0 ? (
                likedNftsData
                  .slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )
                  .map((nft, index) => <NftCard key={index} nft={nft} wishList={true} />)
              ) : (
                <div className="flex flex-col gap-10 justify-center items-center">
                  <img
                    src="/assets/not-found.svg"
                    alt="not found icon"
                    loading="lazy"
                  />
                  <div className="text-white text-center">
                    <StyledH5Heading>No NFT’s Available</StyledH5Heading>
                    <StyledLgText>
                      Looks like there are no NFTs in this collection.
                    </StyledLgText>
                  </div>
                </div>
              )
            ) : activeTab === "My Collection" ? (
              isPurchasedLoading ? (
                [...Array(4)].map((_, index) => (
                  <NFTSkeltonLoader key={index} />
                ))
              ) : purchasedNftsData?.length > 0 ? (
                purchasedNftsData
                  .slice(
                    (currentPage - 1) * itemsPerPage,
                    currentPage * itemsPerPage
                  )
                  .map((nft, index) => <NftCard  key={index} nft={nft} />)
              ) : (
                <div className="flex flex-col gap-10 justify-center items-center">
                  <img
                    src="/assets/not-found.svg"
                    alt="not found icon"
                    loading="lazy"
                  />
                  <div className="text-white text-center">
                    <StyledH5Heading>No NFT’s Available</StyledH5Heading>
                    <StyledLgText>
                      Looks like there are no NFTs in this {activeCategory}{" "}
                      collection.
                    </StyledLgText>
                  </div>
                </div>
              )
            ) : null}
          </div>

          {activeTab === "Wishlist" ? (
            <div className="w-full px-2">
              {likedNftsData?.length > itemsPerPage && (
                <Pagination
                  initialPage={currentPage - 1}
                  pageCount={Math.ceil(likedNftsData.length / itemsPerPage)}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
          ) : (
            <div className="w-full px-2">
              {purchasedNftsData?.length > itemsPerPage && (
                <Pagination
                  initialPage={currentPage - 1}
                  pageCount={Math.ceil(purchasedNftsData.length / itemsPerPage)}
                  onPageChange={handlePageChange}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProfileCollectionNfts;
